package dev.lingvo.site.pages.app.projects.slug.screenshots

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import dev.lingvo.shared.ScreenshotSpecs
import dev.lingvo.site.i18n.tr
import kotlinx.browser.window
import org.w3c.dom.events.Event
import org.w3c.files.File
import dev.lingvo.site.i18n.t

/** Both editor modes use the same viewport breakpoint and bounded artwork intake hints. */
@Composable
internal fun rememberDesignNarrow(): Boolean {
    val query = remember { window.matchMedia("(max-width: 767px)") }
    var narrow by remember { mutableStateOf(query.matches) }
    DisposableEffect(query) {
        val listener: (Event) -> Unit = { narrow = query.matches }
        query.addEventListener("change", listener)
        onDispose { query.removeEventListener("change", listener) }
    }
    return narrow
}

internal fun backgroundRefusal(file: File): String? = when {
    file.size.toDouble() > ScreenshotSpecs.MAX_IMAGE_BYTES -> tr("app.projects.slug.screenshots.design_viewport.this_file_exceeds_8_mib_choose", "This file exceeds 8 MiB. Choose a smaller PNG or JPEG.")
    file.type !in setOf("image/png", "image/jpeg") -> tr("app.projects.slug.screenshots.design_viewport.choose_a_png_or_jpeg_image", "Choose a PNG or JPEG image.")
    else -> null
}
